import { useSteps as Zt, Box as m, Stepper as Kt, Icon as q, Flex as C, Text as A, Link as V, Button as Rt, Image as Xt, IconButton as Jt, theme as Ee, DrawerContent as Qt, DrawerOverlay as qt, Drawer as en, DrawerHeader as tn, DrawerBody as nn, VStack as rn, Skeleton as Ze, HStack as pt, SkeletonCircle as Oe, Grid as ln, GridItem as on, Accordion as an, AccordionItem as sn, AccordionButton as un, AccordionPanel as cn, InputGroup as dn, Input as fn, InputRightElement as hn, Container as pn } from "@everlywell/ui-kit";
import Re, { useEffect as Q, forwardRef as _t, useState as G, useCallback as St, useRef as gn } from "react";
import { Text as xn, useBreakpointValue as Me, Box as vn, InputGroup as mn, Input as bn, InputRightElement as jn, Icon as wn } from "@chakra-ui/react";
import { CaretRight as gt, CaretLeft as Cn, X as yn, MagnifyingGlass as Tt, List as En, Basket as Rn, User as xt, QrCode as _n, CaretDown as Sn, ArrowRight as Tn, InstagramLogo as kn, LinkedinLogo as Dn, FacebookLogo as In, TiktokLogo as Ln, XLogo as An } from "@phosphor-icons/react";
import { motion as rt, AnimatePresence as On } from "framer-motion";
var qe = { exports: {} }, Ce = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var vt;
function Pn() {
  if (vt) return Ce;
  vt = 1;
  var r = Re, l = Symbol.for("react.element"), a = Symbol.for("react.fragment"), o = Object.prototype.hasOwnProperty, u = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function h(y, p, b) {
    var c, E = {}, w = null, g = null;
    b !== void 0 && (w = "" + b), p.key !== void 0 && (w = "" + p.key), p.ref !== void 0 && (g = p.ref);
    for (c in p) o.call(p, c) && !s.hasOwnProperty(c) && (E[c] = p[c]);
    if (y && y.defaultProps) for (c in p = y.defaultProps, p) E[c] === void 0 && (E[c] = p[c]);
    return { $$typeof: l, type: y, key: w, ref: g, props: E, _owner: u.current };
  }
  return Ce.Fragment = a, Ce.jsx = h, Ce.jsxs = h, Ce;
}
var ye = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var mt;
function $n() {
  return mt || (mt = 1, process.env.NODE_ENV !== "production" && function() {
    var r = Re, l = Symbol.for("react.element"), a = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), u = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), h = Symbol.for("react.provider"), y = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), b = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), E = Symbol.for("react.memo"), w = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), S = Symbol.iterator, M = "@@iterator";
    function U(e) {
      if (e === null || typeof e != "object")
        return null;
      var n = S && e[S] || e[M];
      return typeof n == "function" ? n : null;
    }
    var O = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function T(e) {
      {
        for (var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), f = 1; f < n; f++)
          i[f - 1] = arguments[f];
        ne("error", e, i);
      }
    }
    function ne(e, n, i) {
      {
        var f = O.ReactDebugCurrentFrame, j = f.getStackAddendum();
        j !== "" && (n += "%s", i = i.concat([j]));
        var R = i.map(function(v) {
          return String(v);
        });
        R.unshift("Warning: " + n), Function.prototype.apply.call(console[e], console, R);
      }
    }
    var H = !1, Y = !1, Z = !1, ee = !1, I = !1, _;
    _ = Symbol.for("react.module.reference");
    function F(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === o || e === s || I || e === u || e === b || e === c || ee || e === g || H || Y || Z || typeof e == "object" && e !== null && (e.$$typeof === w || e.$$typeof === E || e.$$typeof === h || e.$$typeof === y || e.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === _ || e.getModuleId !== void 0));
    }
    function _e(e, n, i) {
      var f = e.displayName;
      if (f)
        return f;
      var j = n.displayName || n.name || "";
      return j !== "" ? i + "(" + j + ")" : i;
    }
    function ge(e) {
      return e.displayName || "Context";
    }
    function z(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && T("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case o:
          return "Fragment";
        case a:
          return "Portal";
        case s:
          return "Profiler";
        case u:
          return "StrictMode";
        case b:
          return "Suspense";
        case c:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case y:
            var n = e;
            return ge(n) + ".Consumer";
          case h:
            var i = e;
            return ge(i._context) + ".Provider";
          case p:
            return _e(e, e.render, "ForwardRef");
          case E:
            var f = e.displayName || null;
            return f !== null ? f : z(e.type) || "Memo";
          case w: {
            var j = e, R = j._payload, v = j._init;
            try {
              return z(v(R));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var X = Object.assign, J = 0, Se, Te, ke, ie, De, xe, oe;
    function Ie() {
    }
    Ie.__reactDisabledLog = !0;
    function He() {
      {
        if (J === 0) {
          Se = console.log, Te = console.info, ke = console.warn, ie = console.error, De = console.group, xe = console.groupCollapsed, oe = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: Ie,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        J++;
      }
    }
    function ae() {
      {
        if (J--, J === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: X({}, e, {
              value: Se
            }),
            info: X({}, e, {
              value: Te
            }),
            warn: X({}, e, {
              value: ke
            }),
            error: X({}, e, {
              value: ie
            }),
            group: X({}, e, {
              value: De
            }),
            groupCollapsed: X({}, e, {
              value: xe
            }),
            groupEnd: X({}, e, {
              value: oe
            })
          });
        }
        J < 0 && T("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var K = O.ReactCurrentDispatcher, ve;
    function se(e, n, i) {
      {
        if (ve === void 0)
          try {
            throw Error();
          } catch (j) {
            var f = j.stack.trim().match(/\n( *(at )?)/);
            ve = f && f[1] || "";
          }
        return `
` + ve + e;
      }
    }
    var me = !1, ue;
    {
      var Fe = typeof WeakMap == "function" ? WeakMap : Map;
      ue = new Fe();
    }
    function Le(e, n) {
      if (!e || me)
        return "";
      {
        var i = ue.get(e);
        if (i !== void 0)
          return i;
      }
      var f;
      me = !0;
      var j = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var R;
      R = K.current, K.current = null, He();
      try {
        if (n) {
          var v = function() {
            throw Error();
          };
          if (Object.defineProperty(v.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(v, []);
            } catch (W) {
              f = W;
            }
            Reflect.construct(e, [], v);
          } else {
            try {
              v.call();
            } catch (W) {
              f = W;
            }
            e.call(v.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (W) {
            f = W;
          }
          e();
        }
      } catch (W) {
        if (W && f && typeof W.stack == "string") {
          for (var x = W.stack.split(`
`), $ = f.stack.split(`
`), k = x.length - 1, D = $.length - 1; k >= 1 && D >= 0 && x[k] !== $[D]; )
            D--;
          for (; k >= 1 && D >= 0; k--, D--)
            if (x[k] !== $[D]) {
              if (k !== 1 || D !== 1)
                do
                  if (k--, D--, D < 0 || x[k] !== $[D]) {
                    var N = `
` + x[k].replace(" at new ", " at ");
                    return e.displayName && N.includes("<anonymous>") && (N = N.replace("<anonymous>", e.displayName)), typeof e == "function" && ue.set(e, N), N;
                  }
                while (k >= 1 && D >= 0);
              break;
            }
        }
      } finally {
        me = !1, K.current = R, ae(), Error.prepareStackTrace = j;
      }
      var fe = e ? e.displayName || e.name : "", le = fe ? se(fe) : "";
      return typeof e == "function" && ue.set(e, le), le;
    }
    function Be(e, n, i) {
      return Le(e, !1);
    }
    function We(e) {
      var n = e.prototype;
      return !!(n && n.isReactComponent);
    }
    function ce(e, n, i) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return Le(e, We(e));
      if (typeof e == "string")
        return se(e);
      switch (e) {
        case b:
          return se("Suspense");
        case c:
          return se("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case p:
            return Be(e.render);
          case E:
            return ce(e.type, n, i);
          case w: {
            var f = e, j = f._payload, R = f._init;
            try {
              return ce(R(j), n, i);
            } catch {
            }
          }
        }
      return "";
    }
    var te = Object.prototype.hasOwnProperty, be = {}, je = O.ReactDebugCurrentFrame;
    function d(e) {
      if (e) {
        var n = e._owner, i = ce(e.type, e._source, n ? n.type : null);
        je.setExtraStackFrame(i);
      } else
        je.setExtraStackFrame(null);
    }
    function L(e, n, i, f, j) {
      {
        var R = Function.call.bind(te);
        for (var v in e)
          if (R(e, v)) {
            var x = void 0;
            try {
              if (typeof e[v] != "function") {
                var $ = Error((f || "React class") + ": " + i + " type `" + v + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[v] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw $.name = "Invariant Violation", $;
              }
              x = e[v](n, v, f, i, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (k) {
              x = k;
            }
            x && !(x instanceof Error) && (d(j), T("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", f || "React class", i, v, typeof x), d(null)), x instanceof Error && !(x.message in be) && (be[x.message] = !0, d(j), T("Failed %s type: %s", i, x.message), d(null));
          }
      }
    }
    var B = Array.isArray;
    function P(e) {
      return B(e);
    }
    function ze(e) {
      {
        var n = typeof Symbol == "function" && Symbol.toStringTag, i = n && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return i;
      }
    }
    function re(e) {
      try {
        return Ae(e), !1;
      } catch {
        return !0;
      }
    }
    function Ae(e) {
      return "" + e;
    }
    function lt(e) {
      if (re(e))
        return T("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ze(e)), Ae(e);
    }
    var we = O.ReactCurrentOwner, Dt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, it, ot, Ne;
    Ne = {};
    function It(e) {
      if (te.call(e, "ref")) {
        var n = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (n && n.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function Lt(e) {
      if (te.call(e, "key")) {
        var n = Object.getOwnPropertyDescriptor(e, "key").get;
        if (n && n.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function At(e, n) {
      if (typeof e.ref == "string" && we.current && n && we.current.stateNode !== n) {
        var i = z(we.current.type);
        Ne[i] || (T('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', z(we.current.type), e.ref), Ne[i] = !0);
      }
    }
    function Ot(e, n) {
      {
        var i = function() {
          it || (it = !0, T("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", n));
        };
        i.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: i,
          configurable: !0
        });
      }
    }
    function Pt(e, n) {
      {
        var i = function() {
          ot || (ot = !0, T("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", n));
        };
        i.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: i,
          configurable: !0
        });
      }
    }
    var $t = function(e, n, i, f, j, R, v) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: l,
        // Built-in properties that belong on the element
        type: e,
        key: n,
        ref: i,
        props: v,
        // Record the component responsible for creating this element.
        _owner: R
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: f
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: j
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Mt(e, n, i, f, j) {
      {
        var R, v = {}, x = null, $ = null;
        i !== void 0 && (lt(i), x = "" + i), Lt(n) && (lt(n.key), x = "" + n.key), It(n) && ($ = n.ref, At(n, j));
        for (R in n)
          te.call(n, R) && !Dt.hasOwnProperty(R) && (v[R] = n[R]);
        if (e && e.defaultProps) {
          var k = e.defaultProps;
          for (R in k)
            v[R] === void 0 && (v[R] = k[R]);
        }
        if (x || $) {
          var D = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          x && Ot(v, D), $ && Pt(v, D);
        }
        return $t(e, x, $, j, f, we.current, v);
      }
    }
    var Ve = O.ReactCurrentOwner, at = O.ReactDebugCurrentFrame;
    function de(e) {
      if (e) {
        var n = e._owner, i = ce(e.type, e._source, n ? n.type : null);
        at.setExtraStackFrame(i);
      } else
        at.setExtraStackFrame(null);
    }
    var Ye;
    Ye = !1;
    function Ge(e) {
      return typeof e == "object" && e !== null && e.$$typeof === l;
    }
    function st() {
      {
        if (Ve.current) {
          var e = z(Ve.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function Ht(e) {
      return "";
    }
    var ut = {};
    function Ft(e) {
      {
        var n = st();
        if (!n) {
          var i = typeof e == "string" ? e : e.displayName || e.name;
          i && (n = `

Check the top-level render call using <` + i + ">.");
        }
        return n;
      }
    }
    function ct(e, n) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var i = Ft(n);
        if (ut[i])
          return;
        ut[i] = !0;
        var f = "";
        e && e._owner && e._owner !== Ve.current && (f = " It was passed a child from " + z(e._owner.type) + "."), de(e), T('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', i, f), de(null);
      }
    }
    function dt(e, n) {
      {
        if (typeof e != "object")
          return;
        if (P(e))
          for (var i = 0; i < e.length; i++) {
            var f = e[i];
            Ge(f) && ct(f, n);
          }
        else if (Ge(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var j = U(e);
          if (typeof j == "function" && j !== e.entries)
            for (var R = j.call(e), v; !(v = R.next()).done; )
              Ge(v.value) && ct(v.value, n);
        }
      }
    }
    function Bt(e) {
      {
        var n = e.type;
        if (n == null || typeof n == "string")
          return;
        var i;
        if (typeof n == "function")
          i = n.propTypes;
        else if (typeof n == "object" && (n.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        n.$$typeof === E))
          i = n.propTypes;
        else
          return;
        if (i) {
          var f = z(n);
          L(i, e.props, "prop", f, e);
        } else if (n.PropTypes !== void 0 && !Ye) {
          Ye = !0;
          var j = z(n);
          T("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", j || "Unknown");
        }
        typeof n.getDefaultProps == "function" && !n.getDefaultProps.isReactClassApproved && T("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Wt(e) {
      {
        for (var n = Object.keys(e.props), i = 0; i < n.length; i++) {
          var f = n[i];
          if (f !== "children" && f !== "key") {
            de(e), T("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", f), de(null);
            break;
          }
        }
        e.ref !== null && (de(e), T("Invalid attribute `ref` supplied to `React.Fragment`."), de(null));
      }
    }
    var ft = {};
    function ht(e, n, i, f, j, R) {
      {
        var v = F(e);
        if (!v) {
          var x = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var $ = Ht();
          $ ? x += $ : x += st();
          var k;
          e === null ? k = "null" : P(e) ? k = "array" : e !== void 0 && e.$$typeof === l ? (k = "<" + (z(e.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : k = typeof e, T("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", k, x);
        }
        var D = Mt(e, n, i, j, R);
        if (D == null)
          return D;
        if (v) {
          var N = n.children;
          if (N !== void 0)
            if (f)
              if (P(N)) {
                for (var fe = 0; fe < N.length; fe++)
                  dt(N[fe], e);
                Object.freeze && Object.freeze(N);
              } else
                T("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              dt(N, e);
        }
        if (te.call(n, "key")) {
          var le = z(e), W = Object.keys(n).filter(function(Ut) {
            return Ut !== "key";
          }), Ue = W.length > 0 ? "{key: someKey, " + W.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!ft[le + Ue]) {
            var Gt = W.length > 0 ? "{" + W.join(": ..., ") + ": ...}" : "{}";
            T(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ue, le, Gt, le), ft[le + Ue] = !0;
          }
        }
        return e === o ? Wt(D) : Bt(D), D;
      }
    }
    function zt(e, n, i) {
      return ht(e, n, i, !0);
    }
    function Nt(e, n, i) {
      return ht(e, n, i, !1);
    }
    var Vt = Nt, Yt = zt;
    ye.Fragment = o, ye.jsx = Vt, ye.jsxs = Yt;
  }()), ye;
}
process.env.NODE_ENV === "production" ? qe.exports = Pn() : qe.exports = $n();
var t = qe.exports;
const Ke = 60, bt = 6, Mn = (r) => {
  const {
    activeStepIndex: l,
    hideIndicators: a = !1,
    steps: o,
    stepperTheme: u = {
      light: "eggplant.light",
      base: "eggplant.base"
    }
  } = r, { activeStep: s, setActiveStep: h } = Zt({
    index: l,
    count: o.length
  });
  return Q(() => {
    h(l);
  }, [l, h]), /* @__PURE__ */ t.jsx(
    m,
    { position: "relative", width: "100%", "data-testid": "stepper", children: /* @__PURE__ */ t.jsx(
      Kt,
      {
        role: "progressbar",
        index: s,
        width: "100%",
        display: "flex",
        flexWrap: "nowrap",
        children: o.map((y, p) => {
          const b = s === p, c = p === 0, E = p === o.length - 1, w = s > p;
          let g = `${Ke}px`;
          const S = `calc(100% - ((${Ke * (o.length - 1)}px) - (${o.length - 1} * ${bt * 2}px)))`;
          return b ? g = S : (c || E) && (g = `${Ke - bt}px`), /* @__PURE__ */ t.jsx(
            m,
            {
              width: g,
              opacity: w || b ? 1 : 0.2,
              paddingRight: E ? "0" : "6px",
              paddingLeft: c ? "0" : "6px",
              transition: "width 0.4s ease-in-out, opacity 0.4s ease-in-out",
              children: /* @__PURE__ */ t.jsx(
                m,
                {
                  paddingTop: a ? 2 : 5,
                  position: "relative",
                  width: "100%",
                  children: /* @__PURE__ */ t.jsx(
                    m,
                    {
                      width: "100%",
                      position: "absolute",
                      top: "0",
                      backgroundColor: w ? u.light : u.base,
                      height: a ? "4px" : "8px",
                      borderRadius: "4",
                      left: "0"
                    }
                  )
                }
              )
            },
            `step-${p}`
          );
        })
      }
    ) }
  );
}, lr = Re.memo(Mn), ir = ({
  children: r,
  ...l
}) => /* @__PURE__ */ t.jsx(
  xn,
  { color: "tints.uiGrey", fontSize: ["md", null, null, "lg"], ...l, children: r }
), pe = (r, l) => {
  const a = (r == null ? void 0 : r.startsWith("http")) || (r == null ? void 0 : r.startsWith("mailto"));
  return l && !a ? {
    to: r
  } : {
    href: r
  };
}, Xe = _t(
  (r, l) => {
    const {
      label: a,
      additionalContent: o,
      mainTextFontSize: u,
      linkComponent: s,
      href: h,
      ...y
    } = r, p = s || V, b = pe(h, !!s);
    return /* @__PURE__ */ t.jsxs(
      m,
      {
        ref: l,
        as: p,
        display: "flex",
        alignItems: "center",
        gap: [null, null, null, 1],
        justifyContent: [null, null, null, "space-between"],
        paddingY: [3, null, null, 0],
        color: "tints.black",
        _hover: { color: "viridian.base", textDecoration: "none" },
        borderBottom: ["1px", null, null, "unset"],
        borderColor: ["tints.cream", null, null, "unset"],
        width: ["100%", null, null, "fit-content"],
        cursor: "pointer",
        ...b,
        ...y,
        children: [
          /* @__PURE__ */ t.jsx(
            q,
            {
              display: ["none", null, null, "block"],
              as: gt,
              fontSize: "lg",
              color: "viridian.light",
              role: "img",
              "aria-label": "Caret right icon",
              weight: "bold"
            }
          ),
          /* @__PURE__ */ t.jsxs(
            C,
            { alignItems: "center", gap: "1", width: ["100%", null, null, "auto"], children: [
              /* @__PURE__ */ t.jsx(
                A,
                {
                  fontSize: [u || "xl", null, null, "lg"],
                  fontWeight: "medium",
                  children: a
                }
              ),
              o && (typeof o == "string" ? /* @__PURE__ */ t.jsx(
                A,
                {
                  fontSize: ["xl", null, null, "lg"],
                  fontWeight: "medium",
                  color: "tints.uiGrey",
                  sx: {
                    "a:hover &": {
                      color: "viridian.base"
                    }
                  },
                  children: o
                }
              ) : o),
              /* @__PURE__ */ t.jsx(
                q,
                {
                  display: ["block", null, null, "none"],
                  as: gt,
                  fontSize: "2xl",
                  color: "tints.uiGrey",
                  role: "img",
                  "aria-label": "Caret right icon",
                  marginLeft: "auto"
                }
              )
            ] }
          )
        ]
      }
    );
  }
), Pe = _t(
  (r, l) => {
    const { children: a, isSelected: o, ...u } = r, s = r.backgroundColor || (o ? "tints.lightCream" : "transparent");
    return /* @__PURE__ */ t.jsx(
      Rt,
      {
        ref: l,
        borderRadius: "full",
        backgroundColor: s,
        fontSize: "lg !important",
        fontWeight: "normal",
        color: "tints.black",
        sx: {
          "&[href]": {
            textDecoration: "none"
          }
        },
        _before: {
          content: '""',
          position: "absolute",
          top: [null, null, null, -6],
          right: [null, null, null, -2],
          bottom: [null, null, null, -6],
          left: [null, null, null, -2]
        },
        _hover: {
          backgroundColor: s,
          textDecoration: "none",
          filter: "brightness(0.95)"
        },
        ...u,
        children: a
      }
    );
  }
), Hn = ({
  title: r,
  description: l,
  imageSrc: a,
  imageElement: o,
  button: u,
  backgroundColor: s = "viridian.wash",
  onClick: h,
  href: y,
  linkComponent: p
}) => {
  const w = p || V, g = pe(y, !!p), S = Me({
    base: !1,
    tablet: !1,
    largeTablet: !1,
    desktop: !0
  });
  return /* @__PURE__ */ t.jsxs(
    C,
    {
      direction: ["row", null, null, "column"],
      alignItems: ["center"],
      borderRadius: "xl",
      overflow: "hidden",
      height: ["80px", null, null, "272px"],
      backgroundColor: s,
      onClick: h,
      "data-testid": "spotlight-card",
      position: "relative",
      transition: "box-shadow 0.2s ease-in-out",
      border: "1px solid",
      borderColor: "transparent",
      minWidth: ["100%", null, null, "320px"],
      maxWidth: ["100%", null, null, "380px"],
      _hover: {
        boxShadow: "lg",
        textDecoration: "none",
        border: "1px solid",
        borderColor: "tints.white"
      },
      as: S ? C : w,
      ...S ? {} : g,
      children: [
        /* @__PURE__ */ t.jsx(
          m,
          {
            width: ["72px", null, null, "100%"],
            height: ["100%", null, null, "188px"],
            sx: {
              img: {
                height: S ? "188px" : "100%"
              }
            },
            children: a ? /* @__PURE__ */ t.jsx(
              Xt,
              {
                src: a,
                objectFit: "cover",
                width: "100%",
                alt: "",
                "data-testid": "spotlight-card-image"
              }
            ) : /* @__PURE__ */ t.jsx(
              m,
              {
                height: [80, null, null, 188],
                overflow: "hidden",
                children: o
              }
            )
          }
        ),
        /* @__PURE__ */ t.jsxs(
          C,
          {
            direction: ["column", null, null, "row"],
            justifyContent: [null, null, null, "space-between"],
            alignItems: ["left", null, null, "center"],
            padding: "4",
            height: [
              "80px",
              null,
              null,
              "84px"
            ],
            width: "100%",
            bottom: [null, null, null, "0"],
            backgroundColor: [null, null, null, `${s}CC`],
            backdropFilter: [null, null, null, "blur(8px)"],
            flex: "1",
            gap: [null, null, null, 3],
            children: [
              /* @__PURE__ */ t.jsxs(
                C,
                { direction: "column", justifyContent: "center", height: "100%", children: [
                  /* @__PURE__ */ t.jsx(
                    A,
                    { fontSize: "lg", fontWeight: "medium", color: "tints.black", children: r }
                  ),
                  /* @__PURE__ */ t.jsx(
                    A,
                    { fontSize: "sm", color: "tints.darkGrey", children: l }
                  )
                ] }
              ),
              S ? /* @__PURE__ */ t.jsx(m, { children: u }) : null
            ]
          }
        )
      ]
    }
  );
}, he = (r) => /* @__PURE__ */ t.jsx(
  Jt,
  {
    size: "sm",
    width: ["40px", null, null, "46px"],
    height: ["40px", null, null, "46px"],
    padding: ["2 !important", null, null, "3 !important"],
    colorScheme: "whiteCS",
    backgroundColor: "tints.cream",
    sx: {
      svg: {
        width: "24px",
        height: "24px"
      }
    },
    _hover: {
      backgroundColor: "tints.cream",
      filter: "brightness(0.95)"
    },
    ...r
  }
), kt = ({
  color: r = Ee.colors.viridian.base,
  width: l
}) => /* @__PURE__ */ t.jsx(
  vn,
  {
    as: "svg",
    width: l,
    height: "auto",
    viewBox: "0 0 116 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Everlywell Logo",
    children: /* @__PURE__ */ t.jsx(
      "g",
      { id: "Everlywell Logo", children: /* @__PURE__ */ t.jsx(
        "path",
        {
          fill: r,
          id: "Everlywell Logo_2",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M54.8224 1V17.8352H52.4272V1H54.8224ZM5.65731 14.992C4.9835 14.4474 4.59261 13.726 4.48231 12.8278H13.7822C13.9984 10.4829 13.5723 8.70006 12.5039 7.47915C11.4322 6.25824 9.93769 5.64945 8.01698 5.64945C6.23518 5.64945 4.78896 6.22479 3.67214 7.38216C2.55841 8.5395 2 9.92767 2 11.8377C2 13.7476 2.56171 15.273 3.68501 16.4136C4.80831 17.5542 6.30612 18.1229 8.18163 18.1229C9.11125 18.1229 10.0216 17.9489 10.9125 17.5944C11.8034 17.2431 12.533 16.7447 13.1075 16.1025L11.5517 14.5371C11.2095 14.9217 10.7253 15.2294 10.099 15.4636C9.46959 15.6944 8.84662 15.8115 8.22684 15.8115C7.18735 15.8115 6.33197 15.5372 5.65731 14.992ZM10.4671 8.60977C11.0772 9.10817 11.416 9.81395 11.4774 10.7305H4.52751C4.71152 9.81395 5.12475 9.10817 5.77027 8.60977C6.41589 8.11136 7.18735 7.86384 8.08473 7.86384C9.05966 7.86384 9.85696 8.11136 10.4671 8.60977ZM22.1465 17.8819L27.0047 5.93699H24.3771L22.6565 10.2486L20.8424 15.2828L18.8217 9.76697L17.2884 5.93699H14.6382L19.5189 17.8819H22.1465ZM30.3737 12.8244C30.4835 13.7242 30.8741 14.4467 31.5487 14.992C32.2234 15.5372 33.0788 15.8115 34.1181 15.8115C34.7379 15.8115 35.361 15.6944 35.9905 15.4636C36.6166 15.2294 37.1009 14.9217 37.4431 14.5371L38.999 16.1025C38.4244 16.7447 37.6948 17.2431 36.8039 17.5944C35.9129 17.9489 35.0027 18.1229 34.0729 18.1229C32.1975 18.1229 30.6997 17.5542 29.5764 16.4136C28.453 15.273 27.8914 13.7476 27.8914 11.8377C27.8914 9.92767 28.4498 8.5395 29.5635 7.38216C30.6804 6.22479 32.1265 5.64945 33.9084 5.64945C35.829 5.64945 37.3236 6.25824 38.3952 7.47915C39.4638 8.70006 39.8899 10.4829 39.6736 12.8278H30.3769L30.3737 12.8244ZM37.3688 10.7305C37.3075 9.81395 36.9685 9.10817 36.3584 8.60977C35.7483 8.11136 34.951 7.86384 33.9762 7.86384C33.0788 7.86384 32.3073 8.11136 31.6617 8.60977C31.0161 9.10817 30.6029 9.81395 30.4189 10.7305H37.3688ZM44.5032 7.5263L44.3418 5.96085H44.3385H42.108V17.8355H44.5032V11.4031C44.5032 10.3595 44.8001 9.5567 45.3877 8.99473C45.9751 8.43278 46.7112 8.15181 47.5956 8.15181C48.3703 8.15181 49.0417 8.39264 49.6163 8.87432L50.7073 6.70677C49.9811 6.03445 49.0353 5.6966 47.8732 5.6966C46.2914 5.6966 45.1681 6.30539 44.5032 7.5263ZM60.3782 12.3193V5.96054H57.983V12.3428C57.983 14.1089 58.4286 15.5004 59.3195 16.5106C60.2104 17.5241 61.3789 18.0292 62.8186 18.0292C64.552 18.0292 65.8787 17.387 66.7923 16.1025V18.1262C66.7923 19.2669 66.4824 20.1499 65.8626 20.7754C65.2429 21.401 64.494 21.7154 63.6094 21.7154C61.8889 21.7154 60.8754 20.9661 60.5654 19.4742H58.2187C58.3252 20.9326 58.8644 22.0532 59.8327 22.8326C60.8011 23.612 62.1214 24 63.6546 24C65.188 24 66.4727 23.5049 67.5121 22.5081C68.5515 21.5147 69.0712 20.0697 69.0712 18.1731V5.96054H66.6761V12.1521C66.6761 13.1623 66.3791 14.0153 65.7819 14.7043C65.188 15.3967 64.4681 15.7412 63.4933 15.7412C62.5184 15.7412 61.7566 15.4268 61.2047 14.8013C60.6526 14.1725 60.3782 13.3463 60.3782 12.3193ZM81.5989 5.93699L84.3427 15.2828L87.1768 5.93699H89.8496L85.8275 17.8819H83.0385L81.6892 13.9315L80.5724 9.79039L79.4328 13.9315L78.0836 17.8819H75.2945L71.2498 5.93699H73.9453L76.7795 15.2828L79.5232 5.93699H81.5924H81.5989ZM94.65 14.992C93.9754 14.4467 93.5848 13.7242 93.475 12.8244L93.4847 12.8278H102.781C102.998 10.4829 102.572 8.70006 101.503 7.47915C100.431 6.25824 98.9368 5.64945 97.0162 5.64945C95.2343 5.64945 93.785 6.22479 92.668 7.38216C91.5544 8.5395 90.9959 9.92767 90.9959 11.8377C90.9959 13.7476 91.5576 15.273 92.6809 16.4136C93.8043 17.5542 95.3021 18.1229 97.1775 18.1229C98.1073 18.1229 99.0175 17.9489 99.9084 17.5944C100.799 17.2431 101.529 16.7447 102.103 16.1025L100.544 14.5371C100.202 14.9217 99.7212 15.2328 99.0918 15.4636C98.4623 15.6944 97.8393 15.8115 97.2196 15.8115C96.1802 15.8115 95.3247 15.5372 94.65 14.992ZM99.4598 8.60977C100.07 9.10817 100.409 9.81395 100.47 10.7305H93.5202C93.7042 9.81395 94.1175 9.10817 94.763 8.60977C95.4086 8.11136 96.1802 7.86384 97.0774 7.86384C98.0524 7.86384 98.8465 8.11136 99.4598 8.60977ZM107.698 1V17.8352H105.303V1H107.698ZM113.53 17.8352V1H111.135V17.8352H113.53Z"
        }
      ) }
    )
  }
), Fn = (r, l) => {
  let a;
  return (...o) => {
    a && clearTimeout(a), a = setTimeout(() => {
      r(...o);
    }, l);
  };
}, Je = (r) => r.toLowerCase().replace(/['']/g, "").replace(/[^a-z0-9]/g, ""), Bn = (r, l) => {
  r.length < l.length && ([r, l] = [l, r]);
  let a = Array(l.length + 1).fill(0), o = Array(l.length + 1).fill(0);
  for (let u = 0; u <= l.length; u++)
    a[u] = u;
  for (let u = 1; u <= r.length; u++) {
    o[0] = u;
    for (let s = 1; s <= l.length; s++) {
      const h = r[u - 1] === l[s - 1] ? 0 : 1;
      o[s] = Math.min(
        o[s - 1] + 1,
        // Insertion
        a[s] + 1,
        // Deletion
        a[s - 1] + h
        // Substitution
      );
    }
    [a, o] = [o, a];
  }
  return a[l.length];
}, $e = (r, l, a = 0.6) => {
  if (r.length <= 3 || l.length <= 3)
    return r.includes(l) || l.includes(r);
  const o = Bn(r, l), u = Math.max(r.length, l.length);
  return 1 - o / u >= a;
}, jt = (r, l) => {
  const a = r.split(/\s+/);
  return l.length <= 4 ? a.some((o) => o.includes(l)) : a.some((o) => {
    if ($e(o, l))
      return !0;
    if (o.length >= l.length)
      for (let u = 0; u <= o.length - l.length; u++) {
        const s = o.slice(u, u + l.length + 1);
        if ($e(l, s))
          return !0;
      }
    return !1;
  });
}, et = "nav-drawer-hover", tt = "nav-drawer-animation-start", nt = "nav-drawer-animation-end", wt = (r) => {
  window.dispatchEvent(
    new CustomEvent(et, {
      detail: { isHovering: r },
      bubbles: !0,
      cancelable: !0
    })
  );
}, Ct = (r) => {
  window.dispatchEvent(
    new CustomEvent(r, {
      bubbles: !0,
      cancelable: !0
    })
  );
}, Wn = (r = !1, l = !1, a = !1) => r || !l ? "column" : a ? "row" : "row-reverse", zn = rt(Qt), Nn = rt(qt), Qe = ({
  isOpen: r = !1,
  onClose: l,
  title: a,
  navDrawerLinks: o,
  bottomNavButtons: u,
  spotlightCards: s,
  bottomButton: h,
  hasBackButton: y = !0,
  onBackClick: p,
  hasOnlySpotlightCards: b = !1,
  hasSearch: c = !1,
  onSearch: E = () => ({}),
  topOffset: w
}) => {
  var Z, ee;
  const g = Me({
    base: !1,
    tablet: !1,
    largeTablet: !1,
    desktop: !0
  }), S = g ? "top" : "right", [M, U] = G(0), [O, T] = G(!1), ne = () => {
    U((I) => I + 1);
  }, H = St(
    Fn((I) => {
      E(I), ne();
    }, 100),
    []
  );
  Q(() => {
    r && (T(!0), Ct(tt));
  }, [r]);
  const Y = () => {
    r || (T(!1), l()), Ct(nt);
  };
  return /* @__PURE__ */ t.jsx(
    en,
    {
      isOpen: O || r,
      onClose: () => {
        O && g || l();
      },
      placement: S,
      blockScrollOnMount: !1,
      autoFocus: !1,
      ...g ? {
        styleConfig: {
          baseStyle: {
            ...Ee.components.Drawer.baseStyle,
            dialogContainer: {
              ...(ee = (Z = Ee.components.Drawer) == null ? void 0 : Z.baseStyle) == null ? void 0 : ee.dialogContainer,
              // Push the drawer down by the top offset on desktop to not cover the top navigation
              top: g ? `${w}px` : void 0,
              // Lower index on desktop to make sure the drawer is below the top navigation
              zIndex: ["overlay"]
            }
          }
        }
      } : {},
      children: /* @__PURE__ */ t.jsx(
        On,
        { children: r ? /* @__PURE__ */ t.jsxs(
          t.Fragment,
          { children: [
            /* @__PURE__ */ t.jsx(
              Nn,
              {
                backgroundColor: "tints.black",
                top: ["0", null, null, `${w}px`],
                opacity: g ? void 0 : "0.4 !important",
                ...g ? {
                  initial: { opacity: 0 },
                  animate: { opacity: 0.4 },
                  exit: { opacity: 0 },
                  transition: {
                    duration: 0.2,
                    delay: 0.15,
                    ease: "easeOut"
                  }
                } : {}
              }
            ),
            /* @__PURE__ */ t.jsxs(
              zn,
              {
                onClick: (I) => {
                  const F = I.target.closest("a");
                  F && F.href === window.location.href && l();
                },
                onMouseEnter: () => {
                  g && wt(!0);
                },
                onMouseLeave: (I) => {
                  g && (!c || c && (I.target === I.currentTarget || !I.currentTarget.contains(I.target) && !O)) && wt(!1);
                },
                paddingTop: "4",
                paddingX: [4, null, null, 12],
                paddingBottom: "24",
                overflow: ["auto", null, null, "hidden"],
                maxHeight: "100vh",
                position: "relative",
                top: g ? `${w}px !important` : void 0,
                onAnimationComplete: Y,
                boxShadow: "none",
                ...g ? {
                  initial: { height: 0, opacity: 0 },
                  animate: { height: "auto", opacity: 1 },
                  exit: { height: 0, opacity: 0 },
                  transition: { duration: 0.3 }
                } : {},
                children: [
                  !c && g ? null : /* @__PURE__ */ t.jsxs(
                    tn,
                    {
                      padding: "0",
                      flexDirection: c ? "column" : "row",
                      gap: c ? "4" : "0",
                      children: [
                        g ? null : /* @__PURE__ */ t.jsxs(
                          C,
                          {
                            width: "100%",
                            justifyContent: "space-between",
                            alignItems: "center",
                            children: [
                              y ? /* @__PURE__ */ t.jsx(
                                he,
                                {
                                  icon: /* @__PURE__ */ t.jsx(Cn, {}),
                                  onClick: () => {
                                    p && p();
                                  },
                                  "aria-label": "Back"
                                }
                              ) : null,
                              /* @__PURE__ */ t.jsx(
                                A,
                                {
                                  color: "tints.uiGrey",
                                  fontSize: ["xl", null, null, "lg"],
                                  children: a
                                }
                              ),
                              /* @__PURE__ */ t.jsx(
                                he,
                                {
                                  icon: /* @__PURE__ */ t.jsx(yn, {}),
                                  onClick: l,
                                  "aria-label": "Close"
                                }
                              )
                            ]
                          }
                        ),
                        c && /* @__PURE__ */ t.jsxs(
                          mn,
                          { width: "100%", children: [
                            /* @__PURE__ */ t.jsx(
                              bn,
                              {
                                onChange: (I) => {
                                  H(I.target.value);
                                },
                                placeholder: "Search",
                                autoFocus: !0,
                                width: "full",
                                type: "search"
                              }
                            ),
                            /* @__PURE__ */ t.jsx(
                              jn,
                              { pointerEvents: "none", children: /* @__PURE__ */ t.jsx(wn, { as: Tt, color: "gray.500" }) }
                            )
                          ] }
                        )
                      ]
                    }
                  ),
                  /* @__PURE__ */ t.jsx(
                    nn,
                    {
                      paddingX: "0",
                      paddingBottom: [6, null, null, 4],
                      "data-testid": `navbar-drawer-body-${a.toLowerCase()}`,
                      children: /* @__PURE__ */ t.jsxs(
                        rt.div,
                        {
                          ...g ? {
                            initial: { opacity: 0, y: -5 },
                            animate: { opacity: 1, y: 0 },
                            exit: { opacity: 0, y: -5 },
                            transition: {
                              duration: 0.5,
                              delay: 0.2,
                              ease: [0.4, 0, 0.2, 1],
                              exit: {
                                duration: 0.5,
                                delay: 0.2,
                                ease: [0.4, 0, 0.2, 1]
                              }
                            }
                          } : {},
                          style: {
                            display: "flex",
                            flexDirection: Wn(
                              b,
                              g,
                              c
                            ),
                            gap: "24px",
                            justifyContent: "space-between"
                          },
                          children: [
                            s ? /* @__PURE__ */ t.jsx(
                              m,
                              {
                                gap: [3, null, null, 6],
                                display: "flex",
                                justifyContent: [null, null, null, "center"],
                                sx: {
                                  flexWrap: "wrap",
                                  flexDirection: ["column", null, null, "row"]
                                },
                                children: s
                              }
                            ) : null,
                            /* @__PURE__ */ t.jsxs(
                              C,
                              {
                                position: [null, null, null, "relative"],
                                flexDirection: "column",
                                gap: "6",
                                width: ["100%", null, null, c ? null : "auto"],
                                children: [
                                  o ? /* @__PURE__ */ t.jsx(m, { children: o }) : null,
                                  u && !g ? /* @__PURE__ */ t.jsx(m, { children: u }) : null,
                                  h ? /* @__PURE__ */ t.jsx(
                                    m,
                                    {
                                      width: ["100%"],
                                      position: [null, null, null, "absolute"],
                                      bottom: [null, null, null, 0],
                                      children: h
                                    }
                                  ) : null
                                ]
                              }
                            )
                          ]
                        },
                        M
                      )
                    }
                  )
                ]
              }
            )
          ] }
        ) : null }
      )
    }
  );
}, Vn = ({
  desktopTopButtons: r,
  kitRegistrationElement: l,
  profileElement: a,
  cartElement: o,
  onSearchClick: u,
  onMenuClick: s,
  hasSearch: h = !1,
  logoLink: y = "https://www.everlywell.com",
  setTopOffset: p,
  linkComponent: b,
  onLogoClick: c
}) => {
  const E = gn(null), [w, g] = G(!1);
  Q(() => {
    const M = () => g(!0), U = () => g(!1);
    return window.addEventListener(tt, M), window.addEventListener(nt, U), () => {
      window.removeEventListener(
        tt,
        M
      ), window.removeEventListener(nt, U);
    };
  }, []);
  const S = St(() => {
    if (E.current) {
      const M = E.current.getBoundingClientRect();
      p(M.bottom);
    }
  }, []);
  return Q(() => {
    S();
  }, [S]), /* @__PURE__ */ t.jsx(
    m,
    {
      ref: E,
      paddingY: "4",
      paddingX: [4, null, null, 12],
      borderBottom: "1px solid",
      borderColor: "tints.lightCream",
      backgroundColor: "tints.white",
      position: "sticky",
      top: "0",
      width: "100%",
      zIndex: ["sticky", null, null, w ? "modal" : "sticky"],
      onMouseEnter: S,
      children: /* @__PURE__ */ t.jsxs(
        C,
        { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ t.jsxs(
            C,
            { alignItems: "center", gap: "5", children: [
              /* @__PURE__ */ t.jsx(
                m,
                {
                  "aria-label": "Go to homepage",
                  onClick: c,
                  as: b || V,
                  ...pe(y, !!b),
                  children: /* @__PURE__ */ t.jsx(kt, { width: "116px" })
                }
              ),
              /* @__PURE__ */ t.jsx(
                C,
                { display: ["none", null, null, "flex"], children: r }
              )
            ] }
          ),
          /* @__PURE__ */ t.jsxs(
            C,
            { alignItems: "center", gap: "2", children: [
              /* @__PURE__ */ t.jsx(
                m,
                { display: ["none", null, null, "block"], children: l }
              ),
              h ? /* @__PURE__ */ t.jsx(
                he,
                {
                  "aria-label": "Search",
                  icon: /* @__PURE__ */ t.jsx(q, { as: Tt }),
                  onClick: u
                }
              ) : null,
              o,
              /* @__PURE__ */ t.jsx(
                m,
                { display: ["flex", null, null, "none"], children: /* @__PURE__ */ t.jsx(
                  he,
                  {
                    icon: /* @__PURE__ */ t.jsx(En, {}),
                    "aria-label": "menu",
                    "data-testid": "menu-button",
                    onClick: s
                  }
                ) }
              ),
              /* @__PURE__ */ t.jsx(m, { display: ["none", null, null, "block"], children: a })
            ] }
          )
        ] }
      )
    }
  );
}, Yn = ({
  count: r = 0,
  ...l
}) => /* @__PURE__ */ t.jsxs(
  m,
  { position: "relative", display: "inline-block", children: [
    /* @__PURE__ */ t.jsx(he, { icon: /* @__PURE__ */ t.jsx(Rn, {}), ...l }),
    r > 0 && /* @__PURE__ */ t.jsx(
      m,
      {
        display: "flex",
        minWidth: "20px",
        height: "20px",
        py: "4px",
        px: "6px",
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        right: "-4px",
        top: "-4px",
        borderRadius: "32px",
        background: "viridian.base",
        color: "white",
        fontSize: "xs",
        fontWeight: "normal",
        children: r
      }
    )
  ] }
), or = ({
  numDesktopLinks: r = 5,
  showPromoButton: l = !1
}) => /* @__PURE__ */ t.jsx(
  rn,
  { spacing: 0, align: "stretch", children: /* @__PURE__ */ t.jsx(
    m,
    {
      paddingY: 4,
      paddingX: 6,
      borderBottomWidth: "1px",
      borderColor: "tints.lightCream",
      children: /* @__PURE__ */ t.jsxs(
        C,
        { justify: "space-between", align: "center", children: [
          /* @__PURE__ */ t.jsx(Ze, { w: "120px", h: "48px" }),
          /* @__PURE__ */ t.jsxs(
            pt,
            {
              spacing: 8,
              marginLeft: 12,
              display: ["none", null, null, "flex"],
              "data-testid": "desktop-nav",
              children: [
                Array.from({ length: r }).map(
                  (a, o) => /* @__PURE__ */ t.jsx(Ze, { width: "90px", height: "48px" }, o)
                ),
                l && /* @__PURE__ */ t.jsx(Ze, { width: "110px", height: "48px", borderRadius: "full" })
              ]
            }
          ),
          /* @__PURE__ */ t.jsxs(
            pt,
            { spacing: 4, ml: "auto", children: [
              /* @__PURE__ */ t.jsx(
                Oe,
                {
                  width: "120px",
                  height: "48px",
                  display: ["none", null, null, "block"],
                  "data-testid": "register-kit"
                }
              ),
              " ",
              /* @__PURE__ */ t.jsx(Oe, { width: "48px", height: "48px" }),
              " ",
              /* @__PURE__ */ t.jsx(Oe, { width: "48px", height: "48px" }),
              " ",
              /* @__PURE__ */ t.jsx(Oe, { width: "48px", height: "48px" }),
              " "
            ] }
          )
        ] }
      )
    }
  ) }
), Gn = ({
  source: r,
  onSearchCallback: l,
  isActive: a
}) => {
  const [o, u] = G(""), [s, h] = G([]), y = (c, E) => {
    if (!c) return [];
    const g = Je(c).split(/\s+/);
    return E.filter((S) => {
      const M = Je(S.label);
      if (g.some((H) => jt(M, H))) return !0;
      const O = M.split(/\s+/), T = g.some((H) => O.some((Y) => Y.includes(H) || $e(H, Y))), ne = typeof S.additionalContent == "string" && g.some((H) => {
        const Y = Je(S.additionalContent);
        return jt(Y, H) || Y.split(/\s+/).some((Z) => Z.includes(H) || $e(H, Z));
      });
      return T || ne;
    }).sort((S, M) => S.label.localeCompare(M.label));
  }, p = (c) => {
    if (u(c), !c) {
      h([]);
      return;
    }
    const E = y(c, r);
    h(E), l && l(c, E);
  }, b = () => {
    u(""), h([]);
  };
  return Q(() => {
    a || (u(""), h([]));
  }, [a]), {
    query: o,
    results: s,
    handleClose: b,
    handleSearch: p
  };
}, Un = (r) => {
  const l = /* @__PURE__ */ new Set();
  return r.reduce((a, o) => {
    var s;
    const u = ((s = o.sections) == null ? void 0 : s.reduce((h, y) => {
      const p = y.links.filter((b) => l.has(b.label) || b.isSearchable !== !0 ? !1 : (l.add(b.label), !0));
      return [...h, ...p];
    }, [])) ?? [];
    return [...a, ...u];
  }, []);
}, ar = ({
  categories: r = [],
  onCartClick: l,
  mainCategoryLabel: a = "Menu",
  logoLink: o = "https://www.everlywell.com",
  hasSearch: u = !0,
  onSearchClick: s,
  registrationUrl: h,
  profileUrl: y = "https://secure.everlywell.com/login",
  mobileBottomButtons: p = [],
  numberOfCartItems: b = 0,
  linkComponent: c,
  onSearchCallback: E,
  onLinkClick: w,
  onCategoryOpen: g,
  onMobileMenuOpen: S,
  onBackToMainMenu: M,
  onRegisterKitClick: U,
  onProfileClick: O,
  onLogoClick: T,
  shopAllProductsUrl: ne,
  onShopAllProductsClick: H
}) => {
  var te, be, je;
  const [Y, Z] = G(!1), [ee, I] = G(!1), [_, F] = G(null), [_e, ge] = G(!1), [z, X] = G(!1), [J, Se] = G(0), Te = Me({
    base: !1,
    tablet: !1,
    largeTablet: !1,
    desktop: !0
  }) ?? !1;
  Q(() => {
    ae(), F(null);
  }, [Te]);
  const {
    query: ke,
    results: ie,
    handleSearch: De
  } = Gn({
    source: Un(r),
    onSearchCallback: E,
    isActive: ee
  }), xe = ie.length > 0, oe = c || V, Ie = pe(ne, !!c), He = ke && /* @__PURE__ */ t.jsxs(
    C,
    { gap: xe ? "6" : 0, direction: "column", children: [
      xe ? /* @__PURE__ */ t.jsx(A, { color: "tints.uiGrey", children: `${ie.length} Results` }) : /* @__PURE__ */ t.jsxs(
        C,
        { direction: "column", gap: "6", alignItems: "flex-start", children: [
          /* @__PURE__ */ t.jsx(
            A,
            { color: "tints.uiGrey", children: "We didn't find what you were looking for." }
          ),
          /* @__PURE__ */ t.jsx(
            Rt,
            {
              as: oe,
              onClick: H,
              _hover: { textDecoration: "none" },
              width: ["100%", null, null, "auto"],
              ...Ie,
              children: "Shop all products"
            }
          )
        ] }
      ),
      /* @__PURE__ */ t.jsx(
        ln,
        { columns: [1, 1, 1, 4], children: ie.map(
          (d, L) => /* @__PURE__ */ t.jsx(
            on,
            { children: /* @__PURE__ */ t.jsx(
              Xe,
              {
                href: d.href,
                label: d.label,
                additionalContent: d == null ? void 0 : d.additionalContent,
                linkComponent: c
              }
            ) },
            `${d.label}-${L}`
          )
        ) }
      )
    ] }
  ), ae = () => {
    Z(!1), F(null);
  }, K = (d) => "href" in d, ve = (d) => {
    K(d) ? w == null || w(d.label) : F(d);
  }, se = (d) => {
    ge(!0), I(!1), F(null), !K(d) && (d.sections || d.spotlightCards) && F(d);
  }, me = () => {
    ge(!1);
  };
  Q(() => {
    const d = (L) => {
      X(L.detail.isHovering);
    };
    return window.addEventListener(
      et,
      d
    ), () => {
      window.removeEventListener(
        et,
        d
      );
    };
  }, []), Q(() => {
    !_e && !z && (F(null), I(!1));
  }, [_e, z]), Q(() => {
    let d = window.location.href;
    const L = () => {
      const P = window.location.href;
      P !== d && (d = P, ae(), F(null));
    }, B = setInterval(L, 100);
    return window.addEventListener("popstate", L), () => {
      window.removeEventListener("popstate", L), clearInterval(B);
    };
  }, []);
  const ue = r == null ? void 0 : r.map(
    (d, L) => /* @__PURE__ */ t.jsx(
      Pe,
      {
        onMouseEnter: () => {
          se(d), g == null || g(d.label);
        },
        onMouseLeave: me,
        isSelected: (_ == null ? void 0 : _.label) === d.label,
        as: K(d) && oe ? oe : V,
        href: K(d) ? d.href : void 0,
        onClick: K(d) ? () => w == null ? void 0 : w(d.label) : void 0,
        ...d.buttonProps,
        children: d.label
      },
      `${d.label}-${L}`
    )
  ), Fe = (te = r.filter(
    (d) => !K(d) && d.isMobileTopLink !== !1
  )) == null ? void 0 : te.map((d, L) => {
    const B = d;
    return /* @__PURE__ */ t.jsx(
      m,
      {
        onClick: () => {
          ve(B), g == null || g(B.label);
        },
        children: /* @__PURE__ */ t.jsx(
          Xe,
          {
            label: B.label,
            role: "link",
            additionalContent: B.additionalContent,
            mainTextFontSize: "3xl",
            linkComponent: c
          }
        )
      },
      `${B.label}-${L}`
    );
  }), Le = /* @__PURE__ */ t.jsxs(
    t.Fragment,
    { children: [
      /* @__PURE__ */ t.jsx(
        Pe,
        {
          as: V,
          href: y,
          width: "100%",
          backgroundColor: "tints.cream",
          onClick: O,
          children: /* @__PURE__ */ t.jsxs(
            C,
            { gap: "2", children: [
              "My Everly",
              /* @__PURE__ */ t.jsx(q, { as: xt, size: 24 })
            ] }
          )
        },
        "my-everly"
      ),
      /* @__PURE__ */ t.jsx(
        Pe,
        {
          as: V,
          width: "100%",
          href: h,
          backgroundColor: "tints.cream",
          onClick: U,
          children: /* @__PURE__ */ t.jsxs(
            C,
            { gap: "2", children: [
              "Register kit",
              /* @__PURE__ */ t.jsx(q, { as: _n, size: 24 })
            ] }
          )
        },
        "register-kit"
      )
    ] }
  ), Be = /* @__PURE__ */ t.jsxs(
    C,
    { gap: "2", flexDirection: "column", children: [
      p,
      Le
    ] }
  ), We = _ ? /* @__PURE__ */ t.jsx(
    C,
    { direction: ["column", null, null, "row"], gap: "8", children: (be = _ == null ? void 0 : _.sections) == null ? void 0 : be.map((d, L) => {
      const B = [];
      for (let P = 0; P < d.links.length; P += 3)
        B.push(d.links.slice(P, P + 3));
      return /* @__PURE__ */ t.jsxs(
        m,
        { children: [
          /* @__PURE__ */ t.jsx(
            A,
            {
              fontSize: "md",
              color: "tints.uiGrey",
              marginBottom: [0, null, null, 6],
              children: d.title
            }
          ),
          /* @__PURE__ */ t.jsx(
            C,
            {
              flexDirection: ["column", null, null, "row"],
              gap: [null, null, null, 8],
              children: B == null ? void 0 : B.map(
                (P, ze) => /* @__PURE__ */ t.jsx(
                  C,
                  {
                    flexDirection: ["column"],
                    gap: [null, null, null, 5],
                    marginLeft: [null, null, null, -2],
                    children: P == null ? void 0 : P.map(
                      (re, Ae) => /* @__PURE__ */ t.jsx(
                        Xe,
                        {
                          label: re.label,
                          href: re.href,
                          additionalContent: re.additionalContent,
                          linkComponent: c,
                          onClick: () => w == null ? void 0 : w(re.label)
                        },
                        `${re.label}-${Ae}`
                      )
                    )
                  },
                  ze
                )
              )
            }
          )
        ] },
        `${d.title}-${L}`
      );
    }) }
  ) : null, ce = _ != null && _.spotlightCards ? (je = _.spotlightCards) == null ? void 0 : je.map(
    (d, L) => /* @__PURE__ */ t.jsx(Hn, { ...d }, `${d.title}-${L}`)
  ) : /* @__PURE__ */ t.jsx(m, {});
  return /* @__PURE__ */ t.jsxs(
    t.Fragment,
    { children: [
      /* @__PURE__ */ t.jsx(
        Vn,
        {
          desktopTopButtons: ue,
          kitRegistrationElement: /* @__PURE__ */ t.jsx(
            Pe,
            {
              as: V,
              href: h,
              onClick: U,
              backgroundColor: "tints.cream",
              children: "Register Kit"
            }
          ),
          profileElement: /* @__PURE__ */ t.jsx(
            V,
            { href: y, "aria-label": "login", onClick: O, children: /* @__PURE__ */ t.jsx(he, { icon: /* @__PURE__ */ t.jsx(q, { as: xt }), "aria-label": "Profile" }) }
          ),
          cartElement: /* @__PURE__ */ t.jsx(
            Yn,
            {
              "aria-label": "Cart",
              count: b,
              onClick: l
            }
          ),
          onSearchClick: () => {
            I(!ee), s == null || s();
          },
          onMenuClick: () => {
            Z(!0), S == null || S();
          },
          hasSearch: u,
          logoLink: o,
          linkComponent: c,
          onLogoClick: T,
          setTopOffset: Se
        }
      ),
      /* @__PURE__ */ t.jsxs(
        m,
        { position: "relative", zIndex: "modal", children: [
          /* @__PURE__ */ t.jsx(
            Qe,
            {
              isOpen: Y,
              onClose: ae,
              title: a,
              navDrawerLinks: Fe,
              bottomNavButtons: Be,
              hasBackButton: !1,
              topOffset: J
            }
          ),
          /* @__PURE__ */ t.jsx(
            Qe,
            {
              isOpen: !!_,
              onClose: () => {
                ae(), F(null);
              },
              title: (_ == null ? void 0 : _.label) || "",
              navDrawerLinks: We,
              onBackClick: () => F(null),
              spotlightCards: ce,
              hasOnlySpotlightCards: _ == null ? void 0 : _.hasOnlySpotlightCards,
              bottomButton: _ == null ? void 0 : _.bottomButton,
              topOffset: J
            }
          ),
          /* @__PURE__ */ t.jsx(
            Qe,
            {
              isOpen: ee,
              onClose: () => I(!1),
              title: "Search",
              navDrawerLinks: He,
              onSearch: De,
              hasSearch: !0,
              hasBackButton: !1,
              topOffset: J
            }
          )
        ] }
      )
    ] }
  );
}, yt = ({ links: r, linkComponent: l, onLinkClick: a }) => {
  const o = l || V, u = (s) => {
    a && a(s);
  };
  return /* @__PURE__ */ t.jsx(
    C,
    { direction: "column", gap: 6, children: r.map(
      (s) => /* @__PURE__ */ t.jsx(
        A,
        {
          as: o,
          color: "white",
          size: "lg",
          _hover: { color: "viridian.lighter", textDecoration: "none" },
          onClick: () => u(s.label),
          ...pe(s.href, !!l),
          children: s.label
        },
        s.label
      )
    ) }
  );
}, Zn = ({ title: r, links: l, isLast: a }) => {
  const o = a ? "transparent" : `${Ee.colors.viridian.lighter}20`;
  return l ? /* @__PURE__ */ t.jsx(
    sn,
    { borderColor: o, children: ({ isExpanded: u }) => /* @__PURE__ */ t.jsxs(
      t.Fragment,
      { children: [
        /* @__PURE__ */ t.jsxs(
          un,
          { paddingX: 0, paddingY: 4, _hover: { bg: "transparent" }, children: [
            /* @__PURE__ */ t.jsx(
              A,
              { color: "viridian.lighter", size: "lg", flex: "1", textAlign: "left", children: r }
            ),
            /* @__PURE__ */ t.jsx(
              q,
              {
                as: Sn,
                size: "sm",
                color: "viridian.lighter",
                transform: u ? "rotate(-180deg)" : "rotate(0deg)",
                transition: "transform 0.3s ease"
              }
            )
          ] }
        ),
        /* @__PURE__ */ t.jsx(
          cn,
          { pb: 4, px: 0, children: l }
        )
      ] }
    ) }
  ) : null;
}, Kn = ({ title: r, links: l }) => l ? /* @__PURE__ */ t.jsxs(
  m,
  { children: [
    /* @__PURE__ */ t.jsx(
      A,
      { color: "viridian.lighter", mb: 6, fontSize: "lg", children: r }
    ),
    l
  ] }
) : null, Xn = ({
  sections: r,
  linkComponent: l,
  onLinkClick: a
}) => Me({
  base: !1,
  tablet: !1,
  largeTablet: !0,
  desktop: !0
}) ? /* @__PURE__ */ t.jsx(
  C,
  {
    justify: "space-between",
    align: "flex-start",
    children: /* @__PURE__ */ t.jsx(
      C,
      { gap: 120, children: r.map(
        ({ title: u, links: s }) => /* @__PURE__ */ t.jsx(
          Kn,
          {
            title: u,
            links: /* @__PURE__ */ t.jsx(
              yt,
              {
                links: s,
                linkComponent: l,
                onLinkClick: a
              }
            )
          },
          u
        )
      ) }
    )
  }
) : /* @__PURE__ */ t.jsx(
  an,
  {
    allowMultiple: !0,
    defaultIndex: [0],
    width: "100%",
    display: "flex",
    flexDirection: "column",
    children: r.map(
      ({ title: u, links: s }, h) => /* @__PURE__ */ t.jsx(
        Zn,
        {
          title: u,
          links: /* @__PURE__ */ t.jsx(
            yt,
            {
              links: s,
              linkComponent: l,
              onLinkClick: a
            }
          ),
          isLast: h === r.length - 1
        },
        u
      )
    )
  }
), Et = {
  instagram: kn,
  linkedin: Dn,
  facebook: In,
  tiktok: Ln,
  x: An
}, Jn = ({
  socialLinks: r,
  onEmailSubmit: l,
  socialMediaLabel: a,
  newsletterLabel: o,
  onLinkClick: u
}) => {
  const [s, h] = Re.useState(""), y = () => {
    s && l && (l(s), h(""));
  }, p = (c) => {
    c.key === "Enter" && y();
  }, b = (c) => {
    u && u(c);
  };
  return /* @__PURE__ */ t.jsxs(
    m,
    { width: ["100%", null, null, "440px"], children: [
      /* @__PURE__ */ t.jsxs(
        m,
        { mb: [8, 10], children: [
          /* @__PURE__ */ t.jsx(
            A,
            { color: "viridian.lighter", mb: 6, size: "lg", children: o }
          ),
          /* @__PURE__ */ t.jsxs(
            dn,
            { children: [
              /* @__PURE__ */ t.jsx(
                fn,
                {
                  placeholder: "Enter your email",
                  bg: "transparent",
                  border: "1px solid",
                  borderColor: "viridian.lighter",
                  color: "viridian.lighter",
                  _placeholder: { color: "viridian.lighter" },
                  opacity: 0.66,
                  height: "52px",
                  pr: "48px",
                  value: s,
                  onChange: (c) => h(c.target.value),
                  onKeyPress: p
                }
              ),
              /* @__PURE__ */ t.jsx(
                hn,
                { h: "52px", pr: 4, children: /* @__PURE__ */ t.jsx(
                  q,
                  {
                    as: Tn,
                    color: "viridian.lighter",
                    width: "24px",
                    height: "24px",
                    opacity: 0.66,
                    cursor: "pointer",
                    onClick: y,
                    "data-testid": "arrow-right-icon",
                    role: "button",
                    "aria-label": "Submit"
                  }
                ) }
              )
            ] }
          )
        ] }
      ),
      /* @__PURE__ */ t.jsxs(
        m,
        { children: [
          /* @__PURE__ */ t.jsx(
            A,
            { color: "viridian.lighter", marginBottom: 4, size: "lg", children: a }
          ),
          /* @__PURE__ */ t.jsx(
            C,
            { gap: 3, children: r == null ? void 0 : r.map(
              (c) => /* @__PURE__ */ t.jsx(
                V,
                {
                  href: c.href,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  "aria-label": c.name,
                  onClick: () => b(c.name),
                  children: Et[c.name.toLowerCase()] && /* @__PURE__ */ t.jsx(
                    q,
                    {
                      as: Et[c.name.toLowerCase()],
                      color: "white",
                      width: ["48px", null, "24px", null],
                      height: ["48px", null, "24px", null]
                    }
                  )
                },
                c.name
              )
            ) }
          )
        ] }
      )
    ] }
  );
}, Qn = ({
  links: r,
  linkComponent: l,
  onLinkClick: a
}) => {
  const o = l || V, u = (h) => {
    a && a(h);
  }, s = r == null ? void 0 : r.map(
    (h) => /* @__PURE__ */ t.jsx(
      A,
      {
        as: o,
        color: "viridian.lighter",
        size: "sm",
        _hover: { color: "white", textDecoration: "none" },
        onClick: () => u(h.label),
        ...pe(h.href, !!l),
        children: h.label
      },
      h.label
    )
  );
  return /* @__PURE__ */ t.jsxs(
    C,
    {
      direction: ["column", "column", "row"],
      justify: "space-between",
      align: ["flex-start", "flex-start", "center"],
      gap: [6, 6, 0],
      children: [
        /* @__PURE__ */ t.jsx(
          C,
          {
            direction: "row",
            flexWrap: "wrap",
            gap: [4, 6, 10],
            width: ["100%", "auto"],
            children: s
          }
        ),
        /* @__PURE__ */ t.jsxs(
          A,
          { color: "viridian.lighter", fontSize: "sm", children: [
            "© Everlywell ",
            (/* @__PURE__ */ new Date()).getFullYear()
          ] }
        )
      ]
    }
  );
}, sr = Re.forwardRef(({
  navigationSections: r = [],
  disclaimer: l,
  newsletterLabel: a,
  socialMediaLabel: o,
  socialLinks: u,
  complianceLinks: s,
  linkComponent: h,
  onEmailSubmit: y,
  additionalContent: p,
  onLinkClick: b,
  onSocialMediaClick: c
}, E) => /* @__PURE__ */ t.jsx(
  m,
  { as: "footer", bg: "viridian.dark", py: [6, 8], px: [4, 6], ref: E, children: /* @__PURE__ */ t.jsxs(
    pn,
    { size: "fluid", children: [
      /* @__PURE__ */ t.jsxs(
        C,
        { direction: "column", gap: [8, 12], children: [
          /* @__PURE__ */ t.jsx(
            m,
            { children: /* @__PURE__ */ t.jsx(kt, { width: ["150px", "202px"], color: "white" }) }
          ),
          /* @__PURE__ */ t.jsxs(
            C,
            {
              direction: ["column", null, null, "row"],
              justify: "space-between",
              align: ["flex-start"],
              gap: [8, 8, 8, 0],
              children: [
                /* @__PURE__ */ t.jsx(
                  Xn,
                  {
                    sections: r,
                    linkComponent: h,
                    onLinkClick: b
                  }
                ),
                /* @__PURE__ */ t.jsx(
                  Jn,
                  {
                    socialLinks: u,
                    newsletterLabel: a,
                    socialMediaLabel: o,
                    onEmailSubmit: y,
                    onLinkClick: c
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ t.jsxs(
            C,
            {
              direction: ["column", "column", "row"],
              justify: "space-between",
              alignContent: "center",
              align: ["flex-start", "flex-start", "center"],
              gap: [6, 6, 0],
              children: [
                l && /* @__PURE__ */ t.jsx(
                  A,
                  {
                    color: "viridian.lighter",
                    fontSize: "sm",
                    maxWidth: ["100%", "100%", "1024px"],
                    dangerouslySetInnerHTML: { __html: l },
                    sx: {
                      "a:hover": { color: "viridian.light", textDecoration: "underline" }
                    }
                  }
                ),
                p
              ]
            }
          )
        ] }
      ),
      /* @__PURE__ */ t.jsx(
        m,
        {
          borderTop: "1px solid",
          borderColor: `${Ee.colors.viridian.lighter}20`,
          marginTop: "10",
          marginBottom: "8"
        }
      ),
      /* @__PURE__ */ t.jsx(
        Qn,
        {
          disclaimer: l,
          links: s,
          linkComponent: h,
          onLinkClick: b
        }
      )
    ] }
  ) }
));
export {
  Yn as BasketButton,
  ir as CategoryLabel,
  sr as Footer,
  Pe as NavButton,
  or as NavSkeleton,
  Qe as NavbarDrawer,
  Xe as NavbarDrawerLink,
  ar as NavigationBar,
  Hn as SpotlightCard,
  lr as Stepper,
  he as TopNavIconButton,
  Vn as TopNavigation
};
